module.exports = __webpack_public_path__ + "media/images/payments/americanexpress-dark-2ec00a7cec3cd413884224cd8183ff50.svg";